import React from 'react'
import { Box } from '@mui/material'
import { useAppSelector } from 'src/store'

const RecipeStatus = () => {
    const recipe = useAppSelector(x => x.recipes.currentRecipe)
    if (!recipe) { return (<Box />) }
    return (
        <Box>
            <Box>{recipe.name}</Box>
            <Box>
                {recipe.ingredients?.map(ing => {
                    return (
                        <span key={ing.id}>{ing.name}</span>
                    )
                })}
            </Box>
            {recipe.ingredients.length > 0 &&
                <Box>Collapse</Box>
            }
        </Box>
    )


}

export default RecipeStatus